import { useRow as r } from "./index.es761.js";
function c(o, t) {
  const e = r(o), l = e.getCell(t);
  return { row: e, cell: l };
}
export {
  c as useCell
};
//# sourceMappingURL=index.es760.js.map
